<template>
  <v-card>
    <div class="pt-2">
      <v-card flat>
        <v-row class="d-flex justify-space-between padding-bottom">
          <div>
            <v-btn
              depressed
              color="primary"
              v-on:click="back()"
            >
              返回
            </v-btn>
          </div>
          <div>
            <v-row>
            <v-btn
                depressed
                color="primary"
                class="margin-right"
                @click="readonly = false"
                :disabled="!readonly"
            >
              修改
            </v-btn>
            <v-btn
                depressed
                color="primary"
                class="margin-right"
                @click="doSave"
                :disabled="readonly"
            >
              保存
            </v-btn>
            </v-row>
            <v-row class="red--text">点击修改按钮开始录入</v-row>
          </div>
        </v-row>
        <v-row>
          <v-col cols="2" offset="1" class="text-h6">专享改造费用剩余</v-col>
        </v-row>
        <v-row>
          <v-col cols="2" offset="1" class="text-h4">{{ costRemaining }}</v-col>
        </v-row>
        <v-row class="ma-2 text-center overflow-x-auto">
          <v-form ref="implForm">
          <v-simple-table
            fixed-header
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center" rowspan="2">
                    月份
                  </th>
                  <th class="text-center" rowspan="2">
                    改造项目
                  </th>
                  <th class="text-center head" rowspan="2" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    所属科目
                  </th>
                  <th class="text-center head" colspan="3" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    立项流程
                  </th>
                  <th class="text-center head" colspan="3" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    核价流程
                  </th>
                  <th class="text-center head" colspan="5" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    合同流程
                  </th>
                  <th class="text-center" rowspan="2" v-if="!readonly">
                    操作
                  </th>
                </tr>
                <tr>
                  <th class="text-center" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    OA流程编号
                  </th>
                  <th class="text-center" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    立项金额
                  </th>
                  <th class="text-center" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    是否完结
                  </th>
                  <th class="text-center" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    流程页面
                  </th>
                  <th class="text-center" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    立项金额
                  </th>
                  <th class="text-center" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    是否完结
                  </th>
                  <th class="text-center" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    是否签订合同
                  </th>
                  <th class="text-center" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    费用出处
                  </th>
                  <th class="text-center" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    是否付款
                  </th>
                  <th class="text-center" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    付款比例
                  </th>
                  <th class="text-center" style="box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)">
                    剩余尾款
                  </th>
                </tr>
              </thead>
              <tbody>

                  <tr v-for="(item,i) in implementList">
                    <td>
                      <v-select :items="month" outlined dense style="width: 80px" :readonly="readonly" :rules="[rules.required, rules.month]" v-model="item.month"></v-select>
                    </td>
                    <td>
                      <v-select :items="projectList" item-text="itemName" return-object outlined dense style="width: 150px" :readonly="readonly" :rules="[rules.required]" v-model="item.matter"></v-select>
                    </td>
                    <td>
                      <v-text-field outlined dense style="width: 120px" readonly :value="item.matter?item.matter.projectName:''"></v-text-field>
                    </td>
                    <td>
                      <v-text-field outlined dense style="width: 100px" :readonly="readonly" v-model="item.oaCode"></v-text-field>
                    </td>
                    <td>
                      <v-text-field outlined dense style="width: 100px" :readonly="readonly" :rules="[rules.required,rules.number]" v-model="item.projectFee"></v-text-field>
                    </td>
                    <td>
                      <v-select :items="isDoneList" item-text="value" item-value="id" outlined dense style="width: 80px" :readonly="readonly" v-model="item.isProjectDone"></v-select>
                    </td>
                    <td>
                      <v-text-field outlined dense style="width: 100px" :readonly="readonly" v-model="item.pricingPage"></v-text-field>
                    </td>
                    <td>
                      <v-text-field outlined dense style="width: 100px" :readonly="readonly" :rules="[ rules.number]" v-model="item.pricingFee"></v-text-field>
                    </td>
                    <td>
                      <v-select :items="isDoneList" item-value="id" item-text="value" outlined dense style="width: 80px" :readonly="readonly" v-model="item.isPricingDone"></v-select>
                    </td>
                    <td>
                      <v-select :items="isDoneList" item-text="value" item-value="id" outlined dense style="width: 80px" :readonly="readonly" v-model="item.isSigned"></v-select>
                    </td>
                    <td>
                      <v-text-field outlined dense style="width: 100px" :readonly="readonly" v-model="item.feeOuter"></v-text-field>
                    </td>
                    <td>
                      <v-select :items="isDoneList" item-text="value" item-value="id" outlined dense style="width: 80px" :readonly="readonly" v-model="item.isPay"></v-select>
                    </td>
                    <td>
                      <v-text-field outlined dense style="width: 100px" :readonly="readonly" :rules="[rules.number]" v-model="item.payScale"></v-text-field>
                    </td>
                    <td>
                      <v-text-field outlined dense style="width: 100px" :readonly="readonly" :rules="[rules.number]" v-model="item.residueFee"></v-text-field>
                    </td>
                    <td v-if="!readonly">
                      <v-btn text color="primary" small @click="deleteItem(i)" v-if="!item.id">删除</v-btn>
                    </td>
                  </tr>

              </tbody>
            </template>
          </v-simple-table>
          </v-form>
        </v-row>
        <v-row>
          <v-btn block depressed outlined color="primary" v-if="!readonly" @click="addItem">
            添加明细
          </v-btn>
        </v-row>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import { default as SpecialCostApi } from "@/api/pd/special/SpecialCostApi.js";
export default {
  props: {
    id: [Number, String],
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      tab: null,
      month: [1,2,3,4,5,6,7,8,9,10,11,12],
      projectList:[],
      isDoneList:[{id:'',value:''},{id:1,value:'是'},{id:0,value:'否'}],
      readonly:true,
      costRemaining:0,
      implementList:[],
      rules:{
        required: value => (!!value || value === 0) || '必填.',
        number:value=> ((!value && value !== 0)||(!isNaN(parseFloat(value)) && value > 0)) || '只能输入数字',
        month:value=> value <= new Date().getMonth()+1 || '只可添加本月之前的数据',
      },
    };
  },
  mounted(){
    // 默认取1
    this.getProjectList();
	  this.getDataFromApi();
  },
  methods:{
    back(){
      this.$emit("back")
    },
    async getProjectList() {
      let me = this;
      let queryUserResp = await SpecialCostApi.getProjectList();
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取专项改造项目失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        throw new Error("获取专项改造项目情况失败(无会话数据)");
      }
      me.projectList = data.data;
    },
    async getDataFromApi() {
      let me = this;
      let queryUserResp = await SpecialCostApi.listImplement({
        costId: me.id
      });
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取专项实施列表失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        throw new Error("获取专项实施列表情况失败(无会话数据)");
      }
      me.costRemaining = data.data.costRemaining;
      let list = data.data.implDetailList;
      for(let impl of list){
        let matter = {itemCode:impl.matterCode, projectName: impl.subjectName, itemName:impl.matterName};
        impl.matter = matter;
      }
      me.implementList = list;
    },
    async doSave() {
      let formValid = this.$refs.implForm.validate();
      if (formValid) {
        let list = this.implementList;
        for (let impl of list) {
          impl.costId = this.id;
          impl.matterCode = impl.matter.itemCode;
          impl.matterName = impl.matter.itemName;
          impl.subjectName = impl.matter.projectName;
        }
        let res = await SpecialCostApi.implementEnter(list);
        if (res.data.code === 200) {
          this.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
          this.getDataFromApi();
          this.readonly = true;
        } else {
          this.$dialog.error({
            text: res.data.msg_detail,
            title: res.data.msg,
          });
        }

      }

    },
    addItem(){
      this.implementList.push({});
    },
    deleteItem(index){
      this.implementList.splice(index,1);
    },
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
  }
};
</script>
<style scoped>
.container{
  padding: 0;
}
.row{
  margin: 0;
}
.padding-bottom{
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}
.padding-top{
  padding-top: 30px;
}
.margin-right{
  margin-right: 12px;
}
.v-application p{
  margin-bottom: 0;
}
.head{
  box-shadow: inset -1px -1px 0px rgb(0 0 0/12%)
}
</style>